import React from 'react';

const SafeIcon = ({ icon: Icon, className = '', ...props }) => {
  if (!Icon) {
    console.warn('Icon component not provided to SafeIcon');
    return null;
  }
  
  return <Icon className={className} {...props} />;
};

export default SafeIcon;